import React, { useEffect, useMemo, useState } from 'react'
import { ProjectFiledAllowedValue } from '../../api/shared'
import { SingleSelectComboboxObject } from '../../../../../legacy-design-system/combobox'

export const AllowedValuesField = ({ field, updateValue }) => {
  const initialAllowedValues = useMemo(
    () => field._projectField?.allowedValues ?? [],
    [field._projectField?.allowedValues]
  )
  const [textInput, setTextInput] = useState<
    ProjectFiledAllowedValue | undefined
  >()

  useEffect(() => {
    setTextInput(
      initialAllowedValues.find((item) => item.id === field.value) ?? ''
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialAllowedValues])

  const updateSelectedValue = (projectField: ProjectFiledAllowedValue) => {
    updateValue(projectField.id)
    setTextInput(projectField)
  }

  return (
    <SingleSelectComboboxObject<ProjectFiledAllowedValue>
      items={[{ items: initialAllowedValues }]}
      value={textInput}
      onChange={updateSelectedValue}
      itemToString={(projectField: ProjectFiledAllowedValue) => {
        return projectField.name
      }}
      disabled={initialAllowedValues.length === 0}
    />
  )
}
